module.exports = __webpack_public_path__ + "static/media/cross.e7a9ec26.svg";